import React, { useEffect, useState } from "react";
import "../../styles/layout.css";
import logo from "../../assets/icons/logo-noText.svg";
import cross from "../../assets/icons/close.svg";
import relax_vector from "../../assets/icons/relax-vector.svg";
import focus_swirl from "../../assets/icons/focus-swirl.svg";
import check from "../../assets/icons/check-white.svg";
import calendar from "../../assets/icons/calendar_add.svg";
import { withScorm } from "react-scorm-provider";
import { ZensoryModule } from "../../ZensoryModule";
import { AnalyticsScreenName } from "../API/AnalyticsApi";
import { MoodId, WelcomePageTabs } from "../Data/constants";
import { RouteId } from "../../Routes";
import { getText, TextId } from "../Util/TextHelper";
import { Interweave } from "interweave";
import {
  isSubmitKey,
  preventDefault,
  stopPropagation,
} from "../UI/KeyPressHelper";
import { getConfiguration } from "../Util/ConfigHelper";
import CloseAndExitPopup from "../Close&ExitPopup";
import { isMacOS } from "../Util/DeviceUtil";
import { listContains } from "../Data/Util/util";
import { LOGGER, LogLevel } from "../Util/Logger";
import profileIcon from "../../assets/icons/profileprofileIcon.png";
import footerLogo from "../../assets/icons/TheZensory_Footer_logo.svg";
import { CustomerId, isHideProfileButton } from "../Data/Models/configuration";
import Schedule from "./Schedule";
import SessionModal from "../SessionModal";
import Modal from "../Modal";
import ConnectCalenderModal from "../ConnectCalenderModal";
import { getGlobalAppState } from "../AppState";

const WelcomePage = (props) => {
  const [isGetScheduleData, setIsGetScheduleData] = useState(false);
  const userId = ZensoryModule.getAuth().getCurrentUser();
  const MOOD_IDS = ZensoryModule.getExperienceConfig().getMoods();
  ZensoryModule.getAnalytics().trackScreen(
    AnalyticsScreenName.ScreenChooseMood
  );

  useEffect(() => {
    if (document.getElementById("welcome-box-row")) {
      document.getElementById("welcome-box-row").focus();
    }

    // Check URL parameters on initial load to determine active tab
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get("tab");

    if (tabParam === WelcomePageTabs.Schedule) {
      setShowCurrentTab(WelcomePageTabs.Schedule);
    } else {
      setShowCurrentTab(WelcomePageTabs.Home);
    }
  }, []);

  const [showCloseAndExitPopup, setShowCloseAndExitPopup] = useState(false);
  const [showCurrentTab, setShowCurrentTab] = useState(WelcomePageTabs.Home);
  
  // Update URL parameter when tab changes
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (showCurrentTab === WelcomePageTabs.Schedule) {
      urlParams.set('tab', WelcomePageTabs.Schedule);
    } else {
      urlParams.delete('tab'); // Remove tab param if it's home (default)
    }
    
    // Update the URL without reloading the page
    const newUrl = `${window.location.pathname}${urlParams.toString() ? '?' + urlParams.toString() : ''}${window.location.hash}`;
    window.history.replaceState(null, '', newUrl);
  }, [showCurrentTab]);
  
  const isShowExitButton = ZensoryModule.getFeatureUi().isShowExitButton();
  const isExperienceCompleted =
    ZensoryModule.getSessionHandler().isCompleted() &&
    getConfiguration().customerId !== CustomerId.Brigantia;
  const [isAddSessionModalOpen, setIsAddSessionModalOpen] = useState(false);
  const [isCalenderModalOpen, setIsCalenderModalOpen] = useState(false);
  const [showAddSessionToolTip, setShowAddSessionToolTip] = useState(false);

  const isCalenderLoggedin = getGlobalAppState()?.getUser()?.flags?.isMicrosoftCalendarConnected ?? false;
  const showCalenderModal = !isCalenderLoggedin && !!getGlobalAppState()?.getUser()?.userId;
    useEffect(() => {
    setIsCalenderModalOpen(
        showCalenderModal ?? false
    );
  }, [showCalenderModal]);

  const isShowMood = (moodId) => {
    const show = listContains(moodId, MOOD_IDS);
    LOGGER.log(
      LogLevel.DEBUG,
      `isShowMood() MOOD_IDS=${MOOD_IDS}, moodId=${moodId}, show=${show}`
    );
    return show;
  };

  const startExperience = (e, moodId) => {
    preventDefault(e);
    props.onMood(moodId);
    ZensoryModule.getNavigationHandler().navigate(
      window,
      RouteId.ChooseZense,
      props.onChooseZense
    );
  };

  const close = (e) => {
    preventDefault(e);
    setShowCloseAndExitPopup(true);
    ZensoryModule.getNavigationHandler().exit(window, props.sco);
  };

  const _handleKeyDownTile = (e, moodId) => {
    stopPropagation(e);
    if (isSubmitKey(e)) {
      startExperience(e, moodId);
    }
  };

  const _handleKeyDownProfile = (e) => {
    stopPropagation(e);
    if (isSubmitKey(e)) {
      onProfileClicked(e);
    }
  };

  const _handleKeyDownCloseExit = (e) => {
    stopPropagation(e);
    if (isSubmitKey(e)) {
      close(e);
    }
  };

  // when the version text is clicked
  //   const onVersionClicked = async (e) => {
  //     preventDefault(e);
  //     stopPropagation(e);
  //     await ZensoryModule.getErrorHandler().sendProblemReport();
  //   };

  const onProfileClicked = async (e) => {
    preventDefault(e);
    ZensoryModule.getNavigationHandler().navigate(window, RouteId.Profile);
  };
  const handleOpenCreateSessionModal = () => {
    setIsAddSessionModalOpen(true);
  };
  const handleCloseCreateSessionModal = () => {
    setIsAddSessionModalOpen(false);
  };
  const handleCloseCalenderModal = () => {
    setIsCalenderModalOpen(false);
  };
  const handleShowAddSessionToolTip = () => {
    setShowAddSessionToolTip(true);
  };
  const handleCloseToolTip = () => {
    setShowAddSessionToolTip(false);
  };
  const handleSubmitSessionModal = async () => {
    handleCloseCreateSessionModal();
    setIsGetScheduleData(true);
  };
  return (
    <>
      {showCloseAndExitPopup ? (
        <CloseAndExitPopup
          setShowCloseAndExitPopup={setShowCloseAndExitPopup}
        />
      ) : null}

      <div className="choose-experience-container">
        <div
          className="header-row-welcome"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            paddingTop: "2pc",
            position: "relative", // Ensure the positioning context for z-index
          }}
        >
          <div className="welcome-tabs">
            {Object.values(WelcomePageTabs).map((tab) => (
              <span
                key={tab}
                onClick={() => {setShowCurrentTab(tab)}}
                className={`${tab.toLowerCase()}-tab tab ${
                  showCurrentTab === tab ? "active" : ""
                }`}
              >
                {tab}
              </span>
            ))}
          </div>
          <img
            className="logoNew"
            src={logo}
            alt="Zensory logo"
            style={{
              textAlign: "center", // Center the logo text
              maxWidth: "200px", // Limit the logo's size to avoid taking too much space
            }}
          />
          <div
            className="rightButtons"
            style={{
              display: "flex",
              alignItems: "center",
              zIndex: 1, // Ensure buttons are on top of other elements
            }}
          >
            <div
              className="add-session custom-gradient-border"
              onClick={isCalenderLoggedin ? handleOpenCreateSessionModal : null}
              onMouseOver={
                !isCalenderLoggedin ? handleShowAddSessionToolTip : null
              }
              onMouseOut={!isCalenderLoggedin ? handleCloseToolTip : null}
              style={{
                pointerEvents: ["none", null].includes(userId)
                  ? "none"
                  : "auto",
                cursor: isCalenderLoggedin ? "pointer" : "not-allowed",
              }}
            >
              Add session
              <img src={calendar} alt="calender" />
              {showAddSessionToolTip && !isCalenderLoggedin && (
                <div className="add-session-toolTip">
                  Please login with MS Calender
                </div>
              )}
            </div>
            {isHideProfileButton() ? null : (
              <div
                onClick={(e) => onProfileClicked(e)}
                className="profileButtonContainer"
                tabIndex="0"
                onKeyDown={(e) => _handleKeyDownProfile(e)}
                aria-label={"Profile"}
                role="button"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img src={profileIcon} height={20} alt="Profile" />
                <div className="btn-menu">Profile</div>
              </div>
            )}
            {isShowExitButton ? (
              isHideProfileButton() ? (
                <div
                  id="btn-welcome-close"
                  className="close"
                  onClick={(e) => close(e)}
                  tabIndex="0"
                  onKeyDown={(e) => _handleKeyDownCloseExit(e)}
                  aria-label={getText(TextId.mainCloseAndExitAriaLabel)}
                  alt={getText(TextId.mainCloseAndExitAriaLabel)}
                  role="button"
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={cross}
                    style={{ marginTop: "2px" }}
                    alt="Close icon"
                  />
                  <span>{getText(TextId.mainCloseAndExitText)}</span>
                </div>
              ) : (
                <div
                  onClick={(e) => close(e)}
                  className="profileButtonContainer"
                  tabIndex="0"
                  onKeyDown={(e) => _handleKeyDownCloseExit(e)}
                  aria-label={getText(TextId.mainCloseAndExitAriaLabel)}
                  role="button"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <img src={cross} height={20} alt="Close and Exit" />
                  <div className="btn-menu">Close & Exit</div>
                </div>
              )
            ) : null}
          </div>
        </div>
        {showCurrentTab === WelcomePageTabs.Home ? (
          <>
            <h1
              className={
                isExperienceCompleted
                  ? "welcome-heading-complete"
                  : "welcome-heading"
              }
            >
              {isExperienceCompleted && isShowExitButton ? (
                <span>
                  <img src={check} className="checkmark" alt="Check icon" />
                </span>
              ) : null}
            </h1>
            <div className="welcome-boxes-wrapper">
              <div className="welcome-boxes">
                <div className="homeWelcome-title">
                  <Interweave
                    content={getText(TextId.homeWelcomeExperienceTitle)}
                  />
                </div>
                <div className="box-row" tabIndex="-1" id="welcome-box-row">
                  {isShowMood(MoodId.Focused) ? (
                    <div
                      onClick={(e) => startExperience(e, MoodId.Focused)}
                      id="tile-focus"
                      className={`focus-box custom-gradient-border`}
                      tabIndex="0"
                      onKeyDown={(e) => _handleKeyDownTile(e, MoodId.Focused)}
                      aria-label="Focus Mood selection tile"
                      alt="Focus Mood selection tile"
                    >
                      <div className="focus-box-inner">
                        <div className="focus-box-front">
                          <img
                            className="focus-box-vector"
                            src={focus_swirl}
                            alt="focus vector"
                          />
                          <div
                            className="focus-box-front-headings"
                            role={isMacOS() ? "textbox" : null}
                          >
                            <div>
                              <Interweave
                                content={getText(
                                  TextId.homeWelcomeFocusBoxFrontHeading
                                )}
                              />
                            </div>
                            <div className="focus-box-subheading">
                              <Interweave
                                content={getText(
                                  TextId.homeWelcomeFocusBoxFrontSubHeading
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div
                    onClick={(e) => startExperience(e, MoodId.Relax)}
                    id="tile-relax"
                    className={`relax-box custom-gradient-border`}
                    tabIndex="0"
                    onKeyDown={(e) => _handleKeyDownTile(e, MoodId.Relax)}
                    alt="Relax Mood selection tile"
                    aria-label="Relax Mood selection tile"
                  >
                    <div className="focus-box-inner">
                      <div className="focus-box-front">
                        <img
                          className="focus-box-vector"
                          src={relax_vector}
                          alt="relax vector"
                        />
                        <div
                          className="focus-box-front-headings"
                          role={isMacOS() ? "textbox" : null}
                        >
                          <div>
                            {getText(TextId.homeWelcomeRelaxBoxFrontHeading)}
                          </div>
                          <div className="focus-box-subheading">
                            {getText(TextId.homeWelcomeRelaxBoxFrontSubHeading)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <Schedule
            isGetSchduleData={isGetScheduleData}
            handleIsGetSchduleData={() => setIsGetScheduleData(false)}
            showCalenderModal={showCalenderModal}
          />
        )}
        <div className="web-version" id="version-welcome">
          <img src={footerLogo} alt="Footer logo" />
        </div>
        <Modal
          isOpen={isAddSessionModalOpen}
          onClose={handleCloseCreateSessionModal}
        >
          <SessionModal
            isCreate={true}
            onClose={handleCloseCreateSessionModal}
            onSubmit={handleSubmitSessionModal}
          />
        </Modal>
        <Modal isOpen={isCalenderModalOpen} onClose={handleCloseCalenderModal}>
          <ConnectCalenderModal onClose={handleCloseCalenderModal} />
        </Modal>
      </div>
    </>
  );
};

const Welcome = withScorm()(WelcomePage);

export default Welcome;
